export default [{
  path: '/service',
  name: 'service',
  meta: {
    layout: 'main'
  },
  component: () => import('@/views/service/index')
}]
